import { render, staticRenderFns } from "./SupplySpend.vue?vue&type=template&id=9b3e2c4c&scoped=true&"
import script from "./SupplySpend.vue?vue&type=script&lang=js&"
export * from "./SupplySpend.vue?vue&type=script&lang=js&"
import style0 from "./SupplySpend.vue?vue&type=style&index=0&id=9b3e2c4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3e2c4c",
  null
  
)

export default component.exports